import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Chip,
  FormControl,
  Grid,
  InputLabel,
  List,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import DrawerComponentView from "src/app/components/drawer/drawer.view";
import DrawerAwareContainerComponentView from "src/app/components/drawerAwareContainer/drawerAwareContainer.view";
import SnackBarComponentView from "src/app/components/snackbar/snackbar.view";
import colorsConstants from "src/app/constants/colors.constants";
import TimeSlot from "src/app/models/screens/availabilityTimeslot.model";
import AvaialbilityManagementScreenViewModel from "src/app/screens/availabilityManagement/availabilityManagement.viewmodel";
import styles from "src/app/styles/screens/availabilityManagement.screen.style";

const AvaialbilityManagementScreenView: React.FC = () => {
  const {
    days,
    userWeeklyTemplate,
    onWeeklyTemplateDayExpansionUpdated,
    isWeeklyTemplateExpanded,
    minutesToTimeString,
    onCalendarClicked,
    tags,
    role,
    children,
    isLoadingChildren,
    selectedAvailabilityOwnerId,
    onSelectedAvailabilityOwnerChanged,
    isSnackbarError,
    snackbarMessage,
    isDisplayingSnackbar,
    setIsDisplayingSnackbar,
  } = AvaialbilityManagementScreenViewModel();
  return (
    <Box sx={styles.parent}>
      <DrawerComponentView selectedId="Availability" />
      <DrawerAwareContainerComponentView
        drawerWidth={250}
        sx={styles.mainScreenContentContainer}
      >
        <Grid container justifyContent="center">
          <Grid
            size={{ xl: 10, lg: 10, md: 10, sm: 8, xs: 8 }}
            sx={styles.titleContainer}
          >
            <Typography
              textTransform="math-auto"
              component="span"
              sx={styles.weeklyTemplateText}
            >
              Weekly Template
            </Typography>
            <Button
              variant="outlined"
              sx={{ ml: "auto" }}
              onClick={onCalendarClicked}
            >
              Calendar
            </Button>
          </Grid>
          <Grid size={12}>
            {role === "Parent" && (
              <Grid
                size={{ xl: 4, lg: 5, md: 5, sm: 6, xs: 7 }}
                sx={styles.selectorContainer}
                justifySelf={"flex-end"}
              >
                <Paper elevation={0} sx={styles.selectorPaper}>
                  <FormControl fullWidth>
                    <InputLabel id="availability-owner-select-label">
                      Weekly Template Owner
                    </InputLabel>
                    <Select
                      labelId="availability-owner-select-label"
                      value={selectedAvailabilityOwnerId}
                      label="Weekly Template Owner"
                      onChange={(event: SelectChangeEvent) =>
                        onSelectedAvailabilityOwnerChanged(event.target.value)
                      }
                      disabled={isLoadingChildren}
                    >
                      <MenuItem value="you">You</MenuItem>
                      {children.map((child) => (
                        <MenuItem key={child._id} value={child._id}>
                          {child.firstName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Paper>
              </Grid>
            )}
            <Grid
              sx={styles.weeklyTemplateList}
              size={{ xl: 6, lg: 8, md: 10, sm: 12, xs: 12 }}
              justifySelf={"center"}
            >
              <List>
                {days.map((day: string) => (
                  <Accordion
                    key={day}
                    onChange={(_event, expanded) =>
                      onWeeklyTemplateDayExpansionUpdated(day, expanded)
                    }
                    expanded={isWeeklyTemplateExpanded[day]}
                    disableGutters
                    elevation={0}
                    sx={[
                      {
                        backgroundColor: isWeeklyTemplateExpanded[day]
                          ? colorsConstants.drawerListItemContainerSelected
                          : "transparent",
                      },
                      styles.accordion,
                    ]}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon sx={styles.expandIcon} />}
                    >
                      <Box sx={styles.dayOfWeekRow}>
                        <Typography component="span" sx={styles.dayOfWeekText}>
                          {day}
                        </Typography>
                      </Box>
                    </AccordionSummary>

                    <AccordionDetails>
                      <Box sx={styles.accordionRowContentContainer}>
                        <List sx={styles.dayOfWeekTimeslotsContainer}>
                          {userWeeklyTemplate[day].map(
                            (value: TimeSlot, index: number) => (
                              <Box
                                sx={styles.dayOfWeekTimeslotRowContainer}
                                key={index}
                              >
                                <Box sx={styles.timeslotRowContainer}>
                                  <Typography>
                                    {minutesToTimeString(value.from)} -{" "}
                                    {minutesToTimeString(value.to)}
                                  </Typography>

                                  <Chip
                                    key={value.tag}
                                    label={value.tag}
                                    variant="filled"
                                    sx={[
                                      styles.timeslotTag,
                                      {
                                        borderColor: tags.get(value.tag),
                                        backgroundColor: tags.get(value.tag),
                                      },
                                    ]}
                                  />
                                </Box>

                                <Typography>{value.description}</Typography>
                              </Box>
                            ),
                          )}
                        </List>
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                ))}
              </List>
            </Grid>
          </Grid>
        </Grid>
      </DrawerAwareContainerComponentView>
      <SnackBarComponentView
        isError={isSnackbarError}
        isOpen={isDisplayingSnackbar}
        message={snackbarMessage}
        onClose={() => setIsDisplayingSnackbar(false)}
      />
    </Box>
  );
};

export default AvaialbilityManagementScreenView;
